import User from "@/lib/user"
import { AssessmentsAPI } from "@/lib/api"
import {
  SET_ASSESSMENT,
  SET_ASSESSMENTS,
  UPDATE_ASSESSMENT
} from "@/store/mutationTypes"

const state = {
  all: []
}
const getters = {
  getAssessments: state => {
    return state.all
  },
  getAssessmentsByUserId: state => id => {
    return state.all.find(el => el.user_id === id)
  }
}
// actions
const actions = {
  async allAssessments({ commit }) {
    commit(SET_ASSESSMENTS, await AssessmentsAPI.list())
  },
  async assessmentsByUserId({ commit }, { userId }) {
    commit(SET_ASSESSMENT, await AssessmentsAPI.get(userId))
  },
  async updateAssessment(
    { commit },
    { userId, primaryType, secondaryType, tertiaryType }
  ) {
    commit(
      UPDATE_ASSESSMENT,
      await AssessmentsAPI.update(userId, {
        primaryType,
        secondaryType,
        tertiaryType
      })
    )
  }
}

// mutations
const mutations = {
  [SET_ASSESSMENTS](state, assessments) {
    state.all = assessments
  },
  [SET_ASSESSMENT](state, assessment) {
    let existing_assessment = state.all.find(
      el => el.user_id == assessment.user_id
    )
    if (existing_assessment) {
      existing_assessment.assessments = assessment.assessments
    } else {
      state.all.push(assessment)
      state.all.sort((a, b) => a.id - b.id)
    }
  },
  reset(state) {
    state.all.splice(0, state.all.length)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
